import { formatCompactCurrency, formatCurrency } from '../../utils/currency';
import { BEIRUT_TIMEZONE } from '../../utils/dashboardPeriods';

// Latin digits everywhere, as in the rest of the app
const DATE_LOCALES = { en: 'en-US', fr: 'fr-FR', ar: 'ar-u-nu-latn', ku: 'ckb-u-nu-latn' };

const dateLocale = (language) => {
  const tag = DATE_LOCALES[language] || 'en-US';
  return Intl.DateTimeFormat.supportedLocalesOf([tag]).length ? tag : 'en-US';
};

export const formatBeirutDate = (ms, language, options) =>
  new Intl.DateTimeFormat(dateLocale(language), { timeZone: BEIRUT_TIMEZONE, ...options }).format(ms);

export const formatBeirutTime = (ms) =>
  new Intl.DateTimeFormat('en-GB', { timeZone: BEIRUT_TIMEZONE, hour: '2-digit', minute: '2-digit' }).format(ms);

export const formatHour = (hour) => `${String(hour).padStart(2, '0')}:00`;

// Left-to-right isolate: in Arabic/Kurdish text a leading "-" or "+" would otherwise jump to the end
const isolate = (text) => `\u2066${text}\u2069`;

export const formatMoney = (value, currency) => isolate(formatCompactCurrency(value, currency));

export const formatSignedMoney = (value, currency) => isolate(formatCompactCurrency(value, currency, { signed: true }));

export const formatExactMoney = (value, currency) => isolate(formatCurrency(value, currency, { compact: false }));

export const formatInteger = (value) => new Intl.NumberFormat('en-US').format(Math.round(value || 0));

export const formatPercent = (pct, digits = 1) => isolate(`${Number(pct).toFixed(digits)}%`);

export const formatSignedPercent = (pct) => isolate(new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: Math.abs(pct) >= 100 ? 0 : 1,
  signDisplay: 'exceptZero'
}).format(pct / 100));
